import React from "react";

const Skills = () => (
  <div className="row skill">
    <div className="three columns header-col">
      <h1>
        <span>Skills</span>
      </h1>
    </div>

    <div className="nine columns main-col">
      

      <div className="bars">
        <ul className="skills">
          <li>
            <span className="bar-expand email-marketing" />
            <em>Email marketing</em>
          </li>
          <li>
            <span className="bar-expand automation" />
            <em>Marketing automation</em>
          </li>
          <li>
            <span className="bar-expand adobe" />
            <em>Adobe Suite</em>
          </li>
          <li>
            <span className="bar-expand html" />
            <em>HTML/CSS</em>
          </li>
          <li>
            <span className="bar-expand node" />
            <em>Nodejs</em>
          </li>
        </ul>
      </div>
    </div>
  </div>
);

export default Skills;



// WEBPACK FOOTER //
// ./src/components/Skills.js